import styled from '@emotion/styled';

import { ButtonWrapper } from '~/src/components/cards/elements';
import { breakpoints, darkGrey } from '~/src/styles';

export const Container = styled.div`
  position: relative;
  width: fit-content;
  margin: auto;
`;

export const Image = styled.img`
  height: auto;
  max-width: 100%;
  object-fit: contain;
  max-height: ${`calc(86vh - var(--Header-Height))`};
  background-color: ${darkGrey};
`;

export const ViewCountWrapper = styled.div`
  position: absolute;
  top: 12px;
  left: 0px;

  background-color: ${darkGrey};
  display: flex;
  align-items: center;
  width: fit-content;
  justify-content: center;
  height: 30px;
  border-radius: 0px 17px 17px 0px;
  text-align: center;
  padding: 0 12px 0 8px;
  gap: 8px;

  ${breakpoints.minDesktop} {
    border-radius: 17px;
    top: 10px;
    left: 10px;
  }
`;

export const ContextMenuButtonWrapper = styled(ButtonWrapper)`
  z-index: 99;
  position: absolute;
  top: 12px;
  right: 12px;
  justify-content: center;
  box-shadow: 3px 3px 6px 0px #7c7c7c40;
`;

export const PlayButtonWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-items: center;
  position: absolute;
`;
